import { useMemo } from 'react';

import { useAdMetricSources } from '~/swr-hooks/ads/meta/useAdMetricSources';
import { type Ad } from '~/swr-hooks/ads/types';

export const AD_METRIC_SOURCE_KEY = 'AD_METRIC_SOURCE_KEY';

export type UseAdMetricSourceParams = {
  adId: Ad['id'] | undefined;
};

export const getAdMetricSourceKey = ({ adId }: UseAdMetricSourceParams) => [AD_METRIC_SOURCE_KEY, { adId }];

export type MetricSource = {
  id: string;
  workspaceId: string;
  versionId: string;
  integrationId: string;
  sourceId: string;
};

export const useAdMetricSource = ({ adId }: UseAdMetricSourceParams) => {
  const adIds = useMemo(() => (adId ? [adId] : []), [adId]);
  const { data, isLoading } = useAdMetricSources({ adIds });

  return {
    data: adId ? data?.[adId] : undefined,
    isLoading,
  };
};
